const baseURL3 = "https://erp.newfriendsjewellers.com:8080";


export default baseURL3;